<template>
    <div class="purchase-page">
        <el-dialog :visible.sync="isVisibleDialogResource" width="700px" :before-close="handleClose">
            <el-descriptions title="资源详细信息" direction="vertical" :column="3" border>
                <el-descriptions-item label="资源名称">{{ resourceData.resourceName }}</el-descriptions-item>
                <el-descriptions-item label="CPU核心数">{{ resourceData.cpuCore }}核</el-descriptions-item>
                
                <el-descriptions-item label="内存容量">{{ resourceData.memoryCapacity }}GB</el-descriptions-item>
                <el-descriptions-item label="硬盘容量">{{ resourceData.hardDisk }}GB</el-descriptions-item>
                <el-descriptions-item label="型号">{{ resourceData.model }}</el-descriptions-item>
                <el-descriptions-item label="卡数">{{ resourceData.cardsNum }}</el-descriptions-item>
                <el-descriptions-item label="组网">{{ resourceData.networking }}</el-descriptions-item>
                <!-- <el-descriptions-item label="台数">5</el-descriptions-item> -->
                <el-descriptions-item label="可租台数">{{ resourceData.rentableNum || '0'}}台</el-descriptions-item>
                <el-descriptions-item label="地点">{{ resourceData.address }}</el-descriptions-item>
                <el-descriptions-item label="资源状态" >
                    <span v-if="resourceData.rentOn == 1">随时可租</span>
                    <span v-else>指定日期可租</span>
                </el-descriptions-item>
                <el-descriptions-item label="可租日期" >{{ resourceData.rentDate || '-'}}</el-descriptions-item>
                <el-descriptions-item label="月租金额" v-if="resourceData.monthRent != null">{{ resourceData.monthRent }}元/月</el-descriptions-item>
                <el-descriptions-item label="年租金额" v-else-if="resourceData.yearRent != null">{{ resourceData.yearRent }}元/年</el-descriptions-item>
                
                <!-- <el-descriptions-item label="可接受的付款方式">{{ resourceData.payType }}</el-descriptions-item> -->
                <el-descriptions-item label="资源描述" :span="12">{{ resourceData.resourceDesc }}</el-descriptions-item>
                <el-descriptions-item label="备注" :span="12">{{ resourceData.remark }}</el-descriptions-item>
            </el-descriptions>
            <!-- <el-descriptions title="用户信息" direction="vertical" :column="2" border class="mt20">
                
            </el-descriptions> -->
           
            <!-- <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="confirmBuy">立即购买</el-button>
            </div> -->
        </el-dialog>
    </div>

</template>

<script>
import {
    resourceReleaseDetail,
} from '@/api/index'
export default {
    props:['isVisibleDialogResource','resId'],
    watch:{
        isVisibleDialogResource(val){
            if(val){
                this.getResourceDetail();
            }
        }
    },
    data(){
        return{
            resourceData:{},
        }
    },
    mounted(){

    },
    methods:{
        async getResourceDetail(){
            const resData = await resourceReleaseDetail(this.resId);
            
            this.resourceData = {};
            if(resData.success){
                this.resourceData = resData.data;
                // this.isVisibleResourceDetail = true;
            }
        },
        // confirmBuy(){

        // },
        handleClose(){
            this.$emit('update:isVisibleDialogResource',false);
        }
    }
    
}
</script>


<style scoped>

.purchase-page{
    cursor:default;
}
.el-date-picker{
    width:100%;
}
/* .handle-input{
    width:220px;
} */
.el-date-editor.el-input,.el-input__inner{
    width:100%;
    
}
</style>